module.exports = __webpack_public_path__ + "static/media/8S.4ff481d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8S.svg
// module id = 80
// module chunks = 0